export default class NavigationGroup {
  constructor(obj) {

    this.id = obj.id;
    this.name = obj.name;

  }

  // accepts store and just returns children
  navigationItems(store) {
    return store.getters['navigationItems/navigationItemsList'].filter(ni => ni.navigationGroupId === this.id);
  }

  // accepts store and authorization plugin
  accessibleItemsCount(store, access) {
    return this.navigationItems(store).reduce((a, b) => a + b.accessibleItemsCount(store, access), 0);
  }

  // accepts store
  totalItemsCount(store) {
    return this.navigationItems(store).reduce((a, b) => a + b.totalItemsCount(store), 0);
  }

  showFreeLabel(store, access) {
    const accessible = this.accessibleItemsCount(store, access);
    const total = this.totalItemsCount(store);

    return accessible !== total && accessible !== 0;
  }

}